import {SplitPageLayout} from '@primer/react'
import {Description} from '../components/overview/Description'
import {ChangeSummary} from '../components/overview/ChangeSummary'
import {Findings} from '../components/overview/Findings'
import {ActivitySection} from '../components/overview/activity/ActivitySection'
import {OverviewPanel} from '../components/overview/OverviewPanel'
import {CollapsiblePanel} from '../components/overview/CollapsiblePanel'
import {useIsDockedPanelCompact, useIsDockedPanelOpen} from '../contexts/DockedPanelContext'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ActionItemsSection} from '../components/overview/action-items/ActionItemsSection'
import {isPullRequestOpenState} from '../utils/pull-request-state'
import {CommentsSection} from '../components/overview/action-items/CommentsSection'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'
import styles from './Overview.module.css'

export function OverviewEntrypoint() {
  return <OverviewComponent />
}

function OverviewComponent() {
  const isDockedPanelOpen = useIsDockedPanelOpen()
  const isCompact = useIsDockedPanelCompact()
  const showMobileSidebar = !isDockedPanelOpen || isCompact
  const isFindingsEnabled = isFeatureEnabled('prs_overview_findings')
  const isActionabilityFrameworkEnabled = isFeatureEnabled('prs_overview_actionability_framework')

  const {pullRequest} = useLayoutRouteData()
  const isPROpen = isPullRequestOpenState(pullRequest.state)

  return (
    <div className={`width-full ${styles.layout}`} data-side-panel-open={isDockedPanelOpen && !isCompact}>
      <SplitPageLayout className={styles.wrapper}>
        <SplitPageLayout.Content as="div" padding="none" className={styles.content}>
          <div className={`d-flex gap-4 flex-column`}>
            <Description />
            {isPROpen && (
              <CollapsiblePanel heading="Action items">
                {isActionabilityFrameworkEnabled && <CommentsSection />}
                <ActionItemsSection />
              </CollapsiblePanel>
            )}
            <ActivitySection />
            <ChangeSummary />
            {isFindingsEnabled && <Findings />}
          </div>
        </SplitPageLayout.Content>
        {showMobileSidebar && (
          <SplitPageLayout.Pane
            position="end"
            sticky
            divider="none"
            padding="none"
            width="large"
            className={styles.panel}
          >
            <OverviewPanel />
          </SplitPageLayout.Pane>
        )}
      </SplitPageLayout>
    </div>
  )
}
